export const ConditionalController = (experimentName, controllerWhenTrue, controllerWhenFalse) => controllerParams => {
  var _controllerParams$app;
  const {
    siteStore
  } = ((_controllerParams$app = controllerParams.appData) == null ? void 0 : _controllerParams$app.context) ?? {};
  if (!(siteStore != null && siteStore.experiments.enabled(experimentName))) {
    return controllerWhenFalse(controllerParams);
  }
  return controllerWhenTrue(controllerParams);
};
//# sourceMappingURL=ConditionalController.js.map